import { useCallback, useEffect, useRef, useState } from 'react';

export function useOutsideClick(callback: (event: PointerEvent) => void) {
  const [targetElement, setTargetElement] = useState<Element | null>(null);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const targetElementCallbackRef = useCallback((element: Element | null) => {
    setTargetElement(element);
  }, []);

  useEffect(() => {
    if (!targetElement) {
      return;
    }

    let clickedInside = false;

    const handlePointerDownInside = () => {
      clickedInside = true;
    };

    const handlePointerUp = (event: PointerEvent) => {
      const target = event.target as HTMLElement;
      if (
        clickedInside ||
        targetElement?.contains(target) ||
        target.closest('select')
      ) {
        clickedInside = false;
        return;
      }
      callbackRef.current(event);
      clickedInside = false;
    };

    targetElement.addEventListener('pointerdown', handlePointerDownInside);
    window.addEventListener('pointerup', handlePointerUp, true);

    return () => {
      targetElement.removeEventListener('pointerdown', handlePointerDownInside);
      window.removeEventListener('pointerup', handlePointerUp, true);
    };
  }, [targetElement]);

  return targetElementCallbackRef;
}
